import React from 'react';
import ContentScreen from './ContentScreen';
import McqScreen from './McqScreen';
import OpenQuestionScreen from './OpenQuestionScreen';
import CodingScreen from './CodingScreen';
import ActivityScreen from './ActivityScreen';
import ReflectionScreen from './ReflectionScreen';

const ScreenRenderer = ({ screen, onAnswer, userResponse, lessonId, showSolution, hints, subjectArea, screenState }) => {
  const screenComponents = {
    'content': ContentScreen,
    'question-mcq': McqScreen,
    'question-open': OpenQuestionScreen,
    'coding': CodingScreen,
    'activity': ActivityScreen,
    'reflection': ReflectionScreen
  };

  const ScreenComponent = screenComponents[screen.type] || ContentScreen;

  return (
    <ScreenComponent
      screen={screen}
      onAnswer={onAnswer}
      userResponse={userResponse}
      lessonId={lessonId}
      showSolution={showSolution}
      hints={hints}
      subjectArea={subjectArea}
      screenState={screenState}
    />
  );
};

export default ScreenRenderer;
